import { Box, Flex, FlexProps } from '@cmpsr/components';
import { FC, ReactNode } from 'react';

interface PageContainerProps extends FlexProps {
  children: ReactNode;
  bgImage?: string;
}

interface PageHeaderProps {
  children: ReactNode;
}

interface PageContentProps {
  children: ReactNode;
  bottomPadding?: string | Record<string, string>;
}

interface PageFooterProps {
  children: ReactNode;
}

const PageContainer: FC<PageContainerProps> & {
  Header: FC<PageHeaderProps>;
  Content: FC<PageContentProps>;
  Footer: FC<PageFooterProps>;
} = ({ children, bgImage, ...rest }) => {
  return (
    <Flex
      flexDirection="column"
      height="100vh"
      width="100%"
      bgImage={{
        base: 'none',
        md: bgImage || 'none',
      }}
      bgRepeat="no-repeat"
      bgPosition="center 100%"
      bgSize="auto 200px"
      overflowY="hidden"
      {...rest}
    >
      {children}
    </Flex>
  );
};

const Header: FC<PageHeaderProps> = ({ children }) => {
  return <Box justifySelf="flex-start">{children}</Box>;
};

const Content: FC<PageContentProps> = ({ children, bottomPadding }) => {
  return (
    <Box flex="1" overflowY="scroll" pb={bottomPadding}>
      {children}
    </Box>
  );
};

const Footer: FC<PageFooterProps> = ({ children }) => {
  return <Box justifySelf="flex-end">{children}</Box>;
};

PageContainer.Header = Header;
PageContainer.Content = Content;
PageContainer.Footer = Footer;

export default PageContainer;
